import React, { Component } from "react";
import { Link } from "react-router-dom";

import Table from "../../../../components/common/table/Table";
import ModalWrapper from "../../../../components/common/modalWrapper/ModalWrapper";
import CompleteProjectModal from "../../../common/completeProjectModal/CompleteProjectModal";
import styles from "./ProjectHired.scss";

class ProjectHired extends Component {
  getActions(index, hire) {
    const sow = (
      <Link
        to={`/company/pitch/${hire.id}/member/${hire.match.member_id}/project/${
          hire.match.project_id
        }/sow`}
        className={styles.blueButton}
      >
        View Sow
      </Link>
    );

    const complete = (
      // We send the member_id to the modalProps as projectId to keep the same functionality but
      // with different information, we need to send the member_id to complete the project as an
      // employer.
      <ModalWrapper
        Modal={CompleteProjectModal}
        modalProps={{
          completeProject: this.props.completeProject,
          projectId: hire.match.member_id
        }}
      >
        <button className={styles.blueButton}>Complete Project</button>
      </ModalWrapper>
    );

    const submitFeedback = (
      <Link
        to={`/company/review/${hire.match.project_id}/member/${
          hire.match.member_id
        }`}
        className={styles.blueButton}
      >
        Submit Feedback
      </Link>
    );

    const feedbackSubmitedComponent = (
      <span className={styles.feedbackSubmitted}>Feedback Submitted</span>
    );

    let reviewSubmitted = false;

    if (!_.isEmpty(hire.match.project.reviews)) {
      hire.match.project.reviews.forEach(review => {
        if (review.source_id == localStorage.getItem("User:Id")) {
          reviewSubmitted = true;
        }
      });
    }

    const buttons = {
      "pitch-accepted": sow,
      sow: sow,
      "in-progress": complete,
      paused: sow,
      completed: submitFeedback,
      reviewed: submitFeedback
    };

    return (
      <div className={styles.actionsContainer}>
        {reviewSubmitted
          ? feedbackSubmitedComponent
          : buttons[hire.match.project.status.name]}
      </div>
    );
  }

  getMemberDisplayText(hire) {
    return (
      <div>
        <Link
          to={`/company/pitch/${hire.id}/member/${
            hire.match.member.id
          }/project/${hire.match.project_id}/memberProfile`}
          className={styles.blackBt}
        >
          {hire.match.member.first_name} {hire.match.member.last_name}
        </Link>
      </div>
    );
  }

  getStatusDisplayText(hire) {
    return <div>{_.get(hire, "match.project.status.display_name")}</div>;
  }

  getMessagesDisplayText(hire) {
    // TODO There is not message count yet.
    return (
      <div>
        <Link
          to={`/company/pitch/${hire.id}/member/${
            hire.match.member.id
          }/project/${hire.match.project_id}/messages`}
          className={styles.blueButton}
        >
          {hire.messages.length} messages
        </Link>
      </div>
    );
  }

  render() {
    const { hired } = this.props;

    const mappedHires = hired.map((hire, index) => {
      return {
        rowKey: hire.match.member.id,
        data: [
          {
            displayText: this.getMemberDisplayText(hire)
          },
          {
            displayText: this.getStatusDisplayText(hire),
            orderByText: hire.match.project.status_id
          },
          {
            displayText: this.getMessagesDisplayText(hire)
          },
          {
            displayText: this.getActions(index, hire)
          }
        ]
      };
    });

    const tableData = {
      headers: [
        {
          displayText: "Member Name",
          sortDisabled: true
        },
        {
          displayText: "Status"
        },
        {
          displayText: "Messages",
          sortDisabled: true
        },
        {
          displayText: "",
          sortDisabled: true
        }
      ],
      rows: mappedHires
    };

    return (
      <section className={styles.hiredContainer}>
        <section className={styles.textFont}>
          <div className={styles.hiredTable}>
            <h2 className={styles.pageTitle}>Selected</h2>
            <p className={styles.pageSubTitle}>
              After you accept a proposal from a candidate and begin work, they
              will be moved to the “Selected” step.
              <br />
              Once the project is delivered, click “Complete Project” to review
              the Member’s performance.
            </p>

            <div className={styles.divider}>
              <div className={styles.top} />
              <div className={styles.bottom} />
            </div>

            <Table
              name="HiredTable"
              colsConfig={["40%", "20%", "20%", "20%"]}
              tableData={tableData}
            />
          </div>
        </section>
      </section>
    );
  }
}

export default ProjectHired;



// WEBPACK FOOTER //
// ./src/routes/employer/projectInformation/components/ProjectHired.js